import { useDisclosure } from "@chakra-ui/react";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Route, Routes, useLocation } from "react-router-dom";
import CookieBanner from "./Components/CookiePolicy/components/cookie-banner";
import { logPageView } from "./ga";
import "./index.css";
import MainAdminPage from "./Modules/Admin/MainAdminPage";
import ConfiguratorDisplay from "./Modules/ModularConfigurator/ConfiguratorDisplay";
import OptionPairGraph from "./Modules/Admin/ReactFlow/OptionPairGraph";
import NotFound from "./Modules/NotFound/NotFound";
import ThankYouPage from "./Modules/ThankYouPage";
import CategoriesPage from "./Modules/Categories/CategoriesPage";
import MainPage from "./Components/MainPage/MainPage";
import { Layout } from "./Components/Layout/Layout";

const useQuery = () => {
   return new URLSearchParams(useLocation().search);
};
function App() {
   const ref = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [currentProduct, setCurrentProduct] = useState<string | null>(null);
   const query = useQuery();
   const [cookies, setCookie] = useCookies([
      "cookieyes-consent",
      "__hssrc",
      "__hssc",
   ]);

   useEffect(() => {
      // Values need to be handled.
      if (!cookies["cookieyes-consent"]) {
         onOpen();
      } else {
         setCookie("cookieyes-consent", true);
      }
      setCookie("__hssrc", true);
      setCookie("__hssc", true);
   }, []);
   useLayoutEffect(() => {
      const product: string | null = query.get("product");
      // Validate that product isz not null and is a valid ProductNames value
      if (product !== null) {
         setCurrentProduct(product);
      }
   }, [query]);

   const location = useLocation();
   useEffect(() => {
      logPageView();
   }, [location]);

   return (
      <>
         <CookieBanner onClose={onClose} isOpen={isOpen} children={undefined} />
         <Routes>
            {/* Default English routes */}
            <Route
               path="/visualize"
               element={
                  <Layout imageRef={ref}>
                     <OptionPairGraph optionPairId={160} />
                  </Layout>
               }
            />
            <Route
               path="/"
               element={
                  <Layout page="main" imageRef={ref}>
                     <MainPage />
                  </Layout>
               }
            />
            <Route
               path="/categories"
               element={
                  <Layout page="categories">
                     <CategoriesPage />
                  </Layout>
               }
            />
            <Route
               path="/products"
               element={
                  <Layout page="configurator">
                     {currentProduct ? (
                        <ConfiguratorDisplay
                           currentProductName={currentProduct}
                        />
                     ) : (
                        <NotFound />
                     )}
                  </Layout>
               }
            />
            <Route
               path="/thank-you"
               element={
                  <Layout page="thank-you">
                     <ThankYouPage />
                  </Layout>
               }
            />
            <Route path="/admin" element={<MainAdminPage />} />

            {/* Icelandic routes with /is prefix */}
            <Route
               path="/is/visualize"
               element={
                  <Layout imageRef={ref}>
                     <OptionPairGraph optionPairId={160} />
                  </Layout>
               }
            />
            <Route
               path="/is"
               element={
                  <Layout page="main" imageRef={ref}>
                     <MainPage />
                  </Layout>
               }
            />
            <Route
               path="/is/categories"
               element={
                  <Layout page="categories">
                     <CategoriesPage />
                  </Layout>
               }
            />
            <Route
               path="/is/products"
               element={
                  <Layout page="configurator">
                     {currentProduct ? (
                        <ConfiguratorDisplay
                           currentProductName={currentProduct}
                        />
                     ) : (
                        <NotFound />
                     )}
                  </Layout>
               }
            />
            <Route
               path="/is/thank-you"
               element={
                  <Layout page="thank-you">
                     <ThankYouPage />
                  </Layout>
               }
            />
            <Route path="/is/admin" element={<MainAdminPage />} />

            {/* Catch all route for 404 */}
            <Route
               path="*"
               element={
                  <Layout page="not-found">
                     <NotFound />
                  </Layout>
               }
            />
         </Routes>
      </>
   );
}

export default App;
